import { render, staticRenderFns } from "./NatureTime.vue?vue&type=template&id=a2c6f3c8&"
import script from "./NatureTime.vue?vue&type=script&lang=js&"
export * from "./NatureTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports